<template>
    <el-dialog
            width="30%"
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px" class="tenant-dialog-form">
            <el-form-item label="租户编码" prop="code">
                <el-input v-model="dataForm.code" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="租户名称" prop="name">
                <el-input v-model="dataForm.name" placeholder=""></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {getTenantById, createTenant, editTenant} from '@/controller/sys'
    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    id: 0,
                    code: '',
                    name: ''
                },
                dataRule: {
                    code: [
                        {required: true, message: '租户编码不能为空', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '租户名称不能为空', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.dataForm.id = id || 0
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        getTenantById({},this.dataForm.id).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.code = data.body.tenantCode
                                this.dataForm.name = data.body.tenantName
                            }
                        })
                    }
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        if(this.dataForm.id){
                            editTenant(
                                {
                                    'id': this.dataForm.id || undefined,
                                    'tenantCode': this.dataForm.code,
                                    'tenantName': this.dataForm.name
                                }
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        duration: 1500,
                                        onClose: () => {
                                            this.visible = false
                                            this.$emit('refreshDataList')
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            }).catch(error => {
                                console.log(error)
                            })
                        }else{
                            createTenant(
                                {
                                    'id': this.dataForm.id || undefined,
                                    'tenantCode': this.dataForm.code,
                                    'tenantName': this.dataForm.name
                                }
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        duration: 1500,
                                        onClose: () => {
                                            this.visible = false
                                            this.$emit('refreshDataList')
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            }).catch(error => {
                                console.log(error)
                            })
                        }
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    .el-dialog__body {
        .tenant-dialog-form {
            width: 90%;
        }
    }
</style>
